import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import '../Css/LogoutModal.css';

const LogoutModal = ({ isOpen, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleConfirmLogout = async () => {
    setIsLoading(true);
    
    try {
      // Simulate API call or logout process
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Clear authentication data
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Navigate to login page
      navigate(`/admin/login`);
      
    } catch (error) {
      console.error('Logout failed:', error);
    } finally {
      setIsLoading(false);
      onClose();
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && !isLoading) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-container">
        <div className="modal-header">
          <div className="modal-icon">
            <FontAwesomeIcon icon={faSignOutAlt} />
          </div>
          <h2 className="modal-title">Logout</h2>
        </div>
        
        <div className="modal-body">
          <p className="modal-message">
            Are you sure you want to logout? You'll need to login again to access the admin panel.
          </p>
        </div>
        
        <div className="modal-footer">
          <button 
            className="modal-button cancel-button"
            onClick={onClose}
            disabled={isLoading}
          >
            <FontAwesomeIcon icon={faTimes} />
            Cancel
          </button>
          <button 
            className="modal-button confirm-button"
            onClick={handleConfirmLogout}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="button-content">
                <div className="spinners"></div>
                <span>Logging out...</span>
              </div>
            ) : (
              <div className="button-content">
                <FontAwesomeIcon icon={faSignOutAlt} />
                <span>Logout</span>
              </div>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;